import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { ListIconBoxItem } from '@next-nx/shared-ui/molecules'
import styles from './ListIconBox.module.sass'


interface Props {
  items: any[]
  className?: string
  editMode?: boolean
}

const ListIconBox = (props: Props) => {

  const { 
    items = [],
    className = '',
    editMode = false,
  } = props

  return items.length ? (
    <div className={`${styles.root} ${className}`}>
      {items.length > 0 && (
      <div className={styles.list}>
        {items.map((x, i) => (
          <div key={i} className={styles.item}>
            {x}
          </div>
        ))}
      </div>
      )}
    </div>
  ) : <></>
}

export default ListIconBox
